module.exports = __webpack_public_path__ + "img/visa.84330a71.svg";